/* Iliza neon reskin — the only behaviour that CSS cannot express on its own.
   Everything else (shimmer, zoom, pulse, flicker) is a CSS keyframe. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveal. Sections start at opacity 0 via CSS, so if this never runs
     they would stay invisible — the observer is created only after we know it
     is supported, and everything is revealed unconditionally otherwise. */
  function initReveal() {
    var targets = document.querySelectorAll('[data-ilz-reveal]');
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('ilz-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ilz-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    targets.forEach(function (el) { io.observe(el); });

    /* Safety net. These sections start at opacity 0 and rely entirely on the
       observer to bring them back, so anything that stops it firing leaves the
       page blank rather than merely un-animated. A backgrounded tab is the
       common case — the rendering loop is paused there, so no callback runs
       until it is focused, which is fine. This guards the cases that never
       recover, and is a no-op once a section has revealed normally. */
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('ilz-in'); });
    }, 4000);
  }

  /* The mobile menu is Dawn's <header-drawer>; its open/close, focus trap and
     submenu handling all live in Dawn's global.js, so there is nothing to do
     here beyond the reveal observer above. */

  function init() { initReveal(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', init);
})();
